<template>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div class="p-primary align-items-center primary-card-color border-bottom">
      <ul class="nav tab-filter-menu d-inline-flex justify-content-flex-end">
        <li
          class="nav-item"
          v-for="(item, index) in userFilterOptions"
          :key="index"
        >
          <a
            href="#"
            class="nav-link font-size-default py-0"
            :class="[
              filteredData.status == item.id
                ? 'active'
                : index === 0 && filteredData.status === ''
                ? 'active'
                : '',
            ]"
            @click.prevent="getFilterValue(item.id)"
          >
            {{ item.value }}
          </a>
        </li>
      </ul>
      <div class="float-right">
        <app-search @input="getSearchValue" />
      </div>
    </div>

    <div class="card-body p-0">
      <app-table
        :id="tableId"
        :options="options"
        :filtered-data="filteredData"
        :search="search"
        @action="getListAction"
        :company_id="id"
      />
      <!-- </div> -->
    </div>

    <invoice-editmodal
      v-if="isEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :closeAddEditModal="closeEditModal"
      @close-modal="closeEditModal"
    />
    <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
  </div>
</template>

<script>
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import { axiosDelete, axiosGet }  from "../../../../Helpers/AxiosHelper";

export default {
  //   extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  data() {
    return {
      isAddEditModalActive: false,
      isEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.INVOICE_LISTING,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("invoice_#"),
            type: "custom-html",
            key: "invoice_number",
            modifier: (value,row) => {
               return `<a href="#" id="${row.invoice_to}"  data-attribute="${row.invoice_to}" @click=${this.myFunction(row.invoice_to)}>${this.$t(value)}</a>`; 
            },
          },
          {
            title: this.$t("customers"),
            type: "custom-html",
            key: "company",
            modifier: (value) => {
              return `<span>${this.$t(value ? value.company_name : '---')}</span>`;
            },
          },
          {
            title: this.$t("invoice_date"),
            type: "custom-html",
            key: "invoice_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              return `<span>${this.$t(value ?? '---' )}</span>`;
            },
          },
          {
            title: this.$t("total"),
            type: "custom-html",
            key: "amount",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("paid_due"),
            type: "custom-html",
            key: "amount_due",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";
              let val = "";

              if (value === "succeeded") {
                ClassName = `success`;
                val = "Paid";
              } else if (value === "pending") {
                ClassName = `warning`;
                val = "Overdue";
              }

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                val
              )}</span>`;
            },
          },
        ],
        showAction: true,
        actionType: "dropdown",
        actions: [
          {
            title: this.$t("Action"),
            icon: "edit",
            type: "none",
          },
          {
            title: this.$t("view_history_report"),
            icon: "eye",
            type: "none",
            // component: "app-add-modal",
            // modalId: "demo-add-edit-Modal",
          },
          {
              title: this.$t('copy'),
              type: 'none',
              icon: 'copy',
          },
          {
              title: this.$t('export_pdf'),
              type: 'none',
              icon: 'download',
          },
          // {
          //     title: this.$t('print'),
          //     type: 'none',
          // },
          {
              title: this.$t('delete'),
              icon: 'trash',
              type: 'none',
              component: 'app-confirmation-modal',
              modalId: 'demo-delete',
          }
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        orderBy: "desc",
        // actionType: "default",
      },
      userFilterOptions: [
        { id: "", value: "All Invoices" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Overdue" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    // 
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;
      
      this.$hub.$emit("reload-" + this.tableId);
    },

    openAddEditModal() {
      // 
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
     closeEditModal() {
      // 
      $("#demo-add-edit-Modal").modal("hide");
      this.isEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view_history_report")) {
           this.view(rowData.invoice_to);
      } else if (actionObj.title == this.$t("Action")) {
        if (rowData.status == "succeeded") {
          this.$toastr.s("You are already paid customer");
        } else {
          this.selectedUrl = `${actions.SINGLE_INVOICE_SHOW}/${rowData.id}`;
          this.isEditModalActive = true;
        }
      }
      else if (actionObj.title == 'Copy') {
        this.copyInvoice();
      }
      else if (actionObj.title == 'Print') {
        this.invoicePrint();
      }
      else if (actionObj.title == this.$t("export_pdf")) {
        this.invoicePdf();
      }
      
      else if (actionObj.title == 'Delete') {
        // this.copyInvoice();
        this.openDeleteModal();
      }
    },
       view(id) {
            this.active = 2;
            this.$emit("id", id);
        },
        myFunction(id){
        let doc = document.getElementById(id);
        if(doc){
            doc.addEventListener('click', () => {
            this.view(doc.dataset.attribute)
            }) 
        }
        },
    copyInvoice() {
      // alert('a');
      let url = `${actions.INVOICE_COPY}/${this.rowData.id}`;
      this.preLoader = true;
      axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          // $("#demo-delete").modal("hide");
          // this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });

    },
    invoicePdf() {
      // alert('a');
      let url = `${actions.INVOICE_PDF}/${this.rowData.id}`;

      window.location = url;
      // router.push(url);
      this.preLoader = true;
      // axiosGet(url)
      //   .then((response) => {
      //     this.deleteLoader = false;
      //     // $("#demo-delete").modal("hide");
      //     // this.cancelled();
      //     this.$toastr.s(response.data.message);
      //     // this.searchAndSelectFilterOptions();
      //   })
      //   .catch(({ error }) => {
      //     // Trigger after error
      //   })
      //   .finally(() => {
      //     this.$hub.$emit("reload-" + this.tableId);
      //   });

    },
    invoicePrint()
    {
      // alert('a');
      let url = `${actions.INVOICE_PDF}/${this.rowData.id}`;

      // window.print(url);
      // router.push(url);
      this.preLoader = true;
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.INVOICE_DESTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    // searchAndSelectFilterOptions() {
    //   this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
    //     let name = this.options.filters.find(
    //       (element) => element.title === this.$t("search_and_select")
    //     );

    //     name.option = response.data.map((name) => {
    //       return {
    //         id: name.name,
    //         value: name.name,
    //       };
    //     });
    //   });
    // },
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
